var StringIt = {
  svg : null,
  selector : null,
  currSlideSelector : null,
  draggingFrom : null,
  draggingString : null,
  fromNodes : [],
  toNodes : [],
  debug : false,

  init : function ( selector ) {
    StringIt.svg = Snap(selector);

    StringIt.selector = selector;
    StringIt.currSlideSelector = '#current-slide ' + selector;

    StringIt.fromNodes = [];
    StringIt.toNodes = [];

    StringIt.activateDots();

    $(StringIt.currSlideSelector + ' #check-answer-btn')
      .on ( 'click', function ( evt ) {
        StringIt.checkAnswer();
      });

    $(StringIt.currSlideSelector + ' #reset-btn')
      .on ( 'click', function ( evt ) {
        StringIt.reset();
      });

    // - SET THE REASON YOU CAN'T CLICK NEXT IF INCOMPLETE
    Courses.content.customReasonNotComplete = function() {
      return {
        reason : 'Please match up each point on the left to the corresponding text on the right to continue.',
        popupDimensions : {
          width  : '350px',
          height : '50px',
        },
      };
    };
  },

  activateDots : function () {
    $(StringIt.currSlideSelector + ' .from-node').each ( function ( index, elem ) {
      StringIt.fromNodes.push ( elem );
    });

    $(StringIt.currSlideSelector + ' .to-node').each ( function ( index, elem ) {
      StringIt.toNodes.push ( elem );
    });

    $(StringIt.currSlideSelector + ' .from-node')
      .on ( 'mousedown', function ( evt ) {
        StringIt.draggingFrom = evt.currentTarget;
        var fromIdx = $(StringIt.draggingFrom).attr('data-idx');
        if ( $(StringIt.selector + '-string-' + fromIdx).length > 0 ) {
          $(StringIt.selector + '-string-' + fromIdx).remove();
        }

        // - IF THE STRING IS ALREADY ATTACHED TO A NODE, WE NEED TO REMOVE IT
        $(StringIt.currSlideSelector + ' .to-node[attached-string="' + fromIdx + '"]').removeAttr ( 'attached-string' );

        var CPs = StringIt.calcString (
          Number($(StringIt.draggingFrom).attr('cx')),
          Number($(StringIt.draggingFrom).attr('cy')),
          evt.offsetX,
          evt.offsetY
        );

        StringIt.draggingString = StringIt.svg.path (
          'M' + CPs[0][0] + ',' + CPs[0][1] + ' ' +
          'C' + CPs[1][0] + ',' + CPs[1][1] + ' ' + CPs[2][0] + ',' + CPs[2][1] + ' ' + CPs[3][0] + ',' + CPs[3][1]
        ).attr({
          id: StringIt.selector.substr(1) + '-string-' + $(StringIt.draggingFrom).attr('data-idx'),
          class: 'string',
          stroke: $(StringIt.draggingFrom).attr('stroke'),
          'strokeWidth': 3,
          fill: 'none',
          'opacity': 1,
        });

        // - END DOT
        $('.to-node:not([attached-string])').each ( function ( index, elem ) {
          $(elem)
            .attr ( 'stroke', '#000' )
            .attr ( 'fill', '#000' );
        });

        StringIt['enddot' + $(StringIt.draggingFrom).attr('data-idx')] = StringIt.svg.circle (
          Math.round ( CPs[3][0] ), Math.round ( CPs[3][1] ), 6
        ).attr({
          id: 'end-dot-' + $(StringIt.draggingFrom).attr('data-idx'),
          stroke: $(StringIt.draggingFrom).attr('stroke'),
          fill: $(StringIt.draggingFrom).attr('fill'),
          strokeWidth: 1,
        });

        StringIt.svg.mousemove ( StringIt.dragString );
        // - SHOW THE CP'S AS CIRCLES WHEN DEBUGGING
        // StringIt.cPt1 = StringIt.svg.circle ( 50, 50, 5 ).attr({'fill':'#900', 'class':'debug'});
        // StringIt.cPt2 = StringIt.svg.circle ( 50, 50, 5 ).attr({'fill':'#009', 'class':'debug'});
        StringIt.draggingString.insertBefore ( StringIt.fromNodes[0] );
      });

    $('svg')
      .on ( 'mouseup', function ( evt ) {
        if ( StringIt.draggingFrom !== null ) {
          StringIt['enddot' + $(StringIt.draggingFrom).attr('data-idx')].remove();
          delete StringIt['enddot' + $(StringIt.draggingFrom).attr('data-idx')];
        }

        StringIt.svg.unmousemove();

        StringIt.elementReleasedOn = Snap.getElementByPoint(evt.clientX, evt.clientY);
        
        if ( StringIt.elementReleasedOn.attr('class') === 'to-node' ) {
          StringIt.elementReleasedOn.attr({
            stroke: $(StringIt.draggingFrom).attr('stroke'),
            fill: $(StringIt.draggingFrom).attr('fill'),
          });
          // - IF THE TO NODE ALREADY HAD A STRING ATTACHED, RESET THAT STRING
          if ( StringIt.elementReleasedOn.attr ( 'attached-string' ) !== null ) {
            var fromIdx = StringIt.elementReleasedOn.attr ( 'attached-string' );
            $(StringIt.selector + '-string-' + fromIdx).remove();
          }

          // - ATTACH THE STRING TO THE DOT IT WAS RELEASED ON
          var CPs = StringIt.calcString (
            Number($(StringIt.draggingFrom).attr('cx')),
            Number($(StringIt.draggingFrom).attr('cy')),
            Number(StringIt.elementReleasedOn.attr('cx')),
            Number(StringIt.elementReleasedOn.attr('cy'))
          );
          // console.log('CPs',JSON.stringify(CPs));
          // - REDRAW THE STRING
          StringIt.draggingString.attr ( 'd', 'M' + CPs[0][0] + ',' + CPs[0][1] + ' ' +
          'C' + CPs[1][0] + ',' + CPs[1][1] + ' ' + CPs[2][0] + ',' + CPs[2][1] + ' ' + CPs[3][0] + ',' + CPs[3][1] );

          // - SET THE INDEX
          StringIt.elementReleasedOn.attr ( 'attached-string', $(StringIt.draggingFrom).attr('data-idx') );
        }
        else {
          if ( StringIt.draggingString !== undefined && StringIt.draggingString !== null ) {
            StringIt.draggingString.remove();
          }
          // - REMOVE CP'S IF DEBUGGING
          if ( StringIt.cPt1 !== undefined ) {
            StringIt.cPt1.remove();
          }
          if ( StringIt.cPt2 !== undefined ) {
            StringIt.cPt2.remove();
          }
        }

        StringIt.draggingString = null;
        StringIt.draggingFrom = null;
      });
  },

  calcString : function ( x1, y1, x2, y2 ) {
    var c0 = [
      x1, y1
    ];
    var c3 = [x2, y2];
    // -  DFACTOR IS DIFFERENCE FACTOR, I WANT THE CONTROL POINTS TO BE NO LOWER THAN 40% ALONG THE LINE AND NO HIGHER THAN 60 PERCENT ALONG THE LINE
    var dFactor1 = (x2-c0[0])/500;
    // - GET DY/DX
    var dy = c3[1]-c0[1];
    var dx = c3[0]-c0[0];
    // - HANG FACTOR GIVES A MORE REALISTIC HANG DIFFERENTIAL BETWEEN CONTROL POINTS WHEN THE STRING HAS A BIGGER DY
    var hangFactor1, hangFactor2, c1PercPosX, c1PosX, c1PosY, c2PercPosX, c2PosX, c2PosY, c1, c2;

    if ( dy > 0 ) {
      hangFactor1 = 1.1+0.002*dy;
      hangFactor2 = 1.1+0.004*dy;
    }
    else {
      hangFactor1 = 1.1+0.004*-dy;
      hangFactor2 = 1.1+0.002*-dy;
    }

    c1PercPosX = (0.5-Math.min(0.2,dFactor1));
    c2PercPosX = (0.5+Math.min(0.2,dFactor1));

    // console.log('c1PercPosX',c1PercPosX);
    c1PosX = c1PercPosX * dx + c0[0];
    // console.log('c2PercPosX',c2PercPosX);
    c2PosX = c2PercPosX * dx + c0[0];

    if ( dy !== 0 && dx !== 0 ) {
      // - DIAGONAL
      // c1PosY =  c0[1] + (((c1PosX - c0[0]) * (dy/dx)) * hangFactor1);
      // c2PosY = c0[1] + (((c2PosX - c0[0]) * (dy/dx)) * hangFactor2);
      if ( dy/dx > 0 ) {
        c1PosY = Number((c0[1] + c3[1]) / 2) + (50 * hangFactor1);
        c2PosY = Number((c0[1] + c3[1]) / 2) + (50 * hangFactor2);
      }
      else if ( dy/dx < 0 ) {
        c1PosY = Number((c0[1] + c3[1]) / 2) + (50 * hangFactor1);
        c2PosY = Number((c0[1] + c3[1]) / 2) + (50 * hangFactor2);
      }
      // else {
      //   c1PosY = ((c0[1] + c3[1]) / 2) + 50;
      //   c2PosY = ((c0[1] + c3[1]) / 2) + 50;
      // }
      // console.log(JSON.stringify([
      //   'dy/dx',dy/dx,
      //   [x1,y1],
      //   [c1PosX,c1PosY],
      //   [c2PosX,c2PosY],
      //   [x2,y2],
      //   ['HF1',hangFactor1],
      //   ['HF2',hangFactor2],
      // ]));
    }
    else if ( dy !== 0 && dx === 0 ) {
      // - IT'S HORIZTONAL
      c1PosY = Number(c0[1]) + (50 * hangFactor1);
      c2PosY = Number(c3[1]) + (50 * hangFactor2);
    }
    else {
      // - IT'S VERTICAL
      c1PosY = Number(c0[1]) + (50 * hangFactor1);
      c2PosY = Number(c3[1]) + (50 * hangFactor2);
    }

    c1 = [c1PosX, c1PosY];
    c2 = [c2PosX, c2PosY];

    // if ( StringIt.debug ) {
    //   StringIt.addDebugNodes(c0,c1,c2,c3);
    // }

    return [
      c0,c1,c2,c3
    ];
  },

  addDebugNodes : function(c0,c1,c2,c3) {
    // - C0
    if ( $('#debug-node-c0').length === 0 ) {
      StringIt.debugc0 = StringIt.svg.circle(Math.round ( c0[0] ),Math.round ( c0[1] ), 6)
      .attr({
        id: 'debug-node-c0',
        stroke: '#F00',
        fill: '#F00',
        strokeWidth: 1,
      });
    }
    else {
      $('#debug-node-c0')
        .attr ( 'cx', Math.round ( c0[0] ) )
        .attr ( 'cy', Math.round ( c0[1] ) );
    }

    // - C1
    if ( $('#debug-node-c1').length === 0 ) {
      StringIt.debugc1 = StringIt.svg.circle(Math.round ( c1[0] ),Math.round ( c1[1] ), 6)
      .attr({
        id: 'debug-node-c1',
        stroke: '#F00',
        fill: '#F00',
        strokeWidth: 1,
      });
    }
    else {
      $('#debug-node-c1')
        .attr ( 'cx', Math.round ( c1[0] ) )
        .attr ( 'cy', Math.round ( c1[1] ) );
    }

    // - C2
    if ( $('#debug-node-c2').length === 0 ) {
      StringIt.debugc2 = StringIt.svg.circle(Math.round ( c2[0] ),Math.round ( c2[1] ), 6)
      .attr({
        id: 'debug-node-c2',
        stroke: '#F00',
        fill: '#F00',
        strokeWidth: 1,
      });
    }
    else {
      $('#debug-node-c2')
        .attr ( 'cx', Math.round ( c2[0] ) )
        .attr ( 'cy', Math.round ( c2[1] ) );
    }

    // - C3
    if ( $('#debug-node-c3').length === 0 ) {
      StringIt.debugc3 = StringIt.svg.circle(Math.round ( c3[0] ),Math.round ( c3[1] ), 6)
      .attr({
        id: 'debug-node-c3',
        stroke: '#F00',
        fill: '#F00',
        strokeWidth: 1,
      });
    }
    else {
      $('#debug-node-c3')
        .attr ( 'cx', Math.round ( c3[0] ) )
        .attr ( 'cy', Math.round ( c3[1] ) );
    }
  },

  dragString : function ( evt ) {

    var CPs = StringIt.calcString (
      Number($(StringIt.draggingFrom).attr('cx')),
      Number($(StringIt.draggingFrom).attr('cy')),
      evt.offsetX,
      evt.offsetY
    );

    StringIt.draggingString.attr ( 'd', 'M' + CPs[0][0] + ',' + CPs[0][1] + ' ' +
    'C' + CPs[1][0] + ',' + CPs[1][1] + ' ' + CPs[2][0] + ',' + CPs[2][1] + ' ' + CPs[3][0] + ',' + CPs[3][1] );

    StringIt['enddot' + $(StringIt.draggingFrom).attr('data-idx')]
    .attr ({
      cx: CPs[3][0],
      cy: CPs[3][1]
    });
    // - SET NEW POSITION OF CP'S WHEN DEBUGGING
    // StringIt.cPt1.attr({'cx':CPs[1][0],'cy':CPs[1][1]});
    // StringIt.cPt2.attr({'cx':CPs[2][0],'cy':CPs[2][1]});
  },

  isOverEndPoint : function ( x, y ) {

  },

  checkAnswer : function ( evt ) {
    var correct = true;
    $(StringIt.currSlideSelector + ' .to-node').each ( function ( index, elem ) {
      if ( $(elem).attr('attached-string') !== $(elem).attr('ct') ) {
        correct = false;
        return false;
      }
    });

    if ( correct ) {
      Courses.popup.showDynamicPopup ( 'That\'s correct, well done.<br><br>You can now close this popup and continue.', {
        width: '500px',
        height: '80px',
      });

      Courses.content.setCurrSlideComplete();
    }
    else {
      Courses.popup.showDynamicPopup ( 'That\'s not quite right.<br><br>Close this popup and click reset to try again.', {
        width: '500px',
        height: '50px',
      });
    }
  },

  reset : function ( evt ) {
    $(StringIt.currSlideSelector + ' path.string').remove();
    $(StringIt.currSlideSelector + ' circle.to-node').attr('attached-string', null);
    $(StringIt.currSlideSelector + ' *.debug').remove();
  },
};
